import { Spinner, Button as ReactButton } from '@a-ui/react';
import React from 'react';
import { translate } from '../../i18n';
import Box from '../../components/Box';
import { api } from '../../hooks/api.hooks';
import ACardHistoryItem from './ACardHistoryItem';

const ACardHistory: React.FC = () => {
  const [isLoading, setLoading] = React.useState(true);
  const [hasMore, setHasMore] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [items, setItems] = React.useState<Api.ACardHistoryItem[]>([]);

  const fetch = async (page = 1) => {
    setLoading(true);
    const { data } = await api.get<Api.ACardHistory>('/acard/history', { params: { page } });
    setItems([...items, ...data.items]);
    setHasMore(data.hasMore);
    setLoading(false);
  };

  const loadMore = React.useCallback(() => {
    setCurrentPage(currentPage + 1);
  }, [currentPage]);

  React.useEffect(() => {
    fetch(currentPage);
  }, [currentPage]);

  if (!items.length && isLoading) {
    return <Spinner />;
  }
  return (
    <Box>
      <ul className="a-list a-list--reset">
        {items.map((item, index) => (
          <li key={`acard-history-${index}`} className="ckp-a-acard-history-item">
            <ACardHistoryItem data={item} />
          </li>
        ))}
      </ul>

      {hasMore && (
        <div className="u-margin-top">
          <ReactButton
            {...(isLoading ? { addOn: { type: 'spinner', align: 'left' } } : {})}
            onClick={loadMore}
          >
            {translate('common.loadMore')}
          </ReactButton>
        </div>
      )}
    </Box>
  );
};

export default ACardHistory;
